/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * Login Messages
 *
 * This contains all the text for the Login component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  email: {
    id: 'login.email',
    defaultMessage: 'Email'
  },
  error: {
    id: 'login.error',
    defaultMessage: 'Invalid username or password',
  },
  errorEmail: {
    id: 'fields.email.error',
    defaultMessage: 'Please enter an email address',
  },
  errorUnexpected: {
    id: 'login.error.unexpected',
    defaultMessage: 'An unexpected error occurred. Please try again. If this error persists, please contact Support.',
  },
  loadingSdk: {
    id: 'login.loadingSdk',
    defaultMessage: 'Loading the SKD',
  },
  nextButton: {
    id: 'login.next',
    defaultMessage: 'Next',
  },
  noActiveTenant: {
    id: 'login.noActiveTenant',
    defaultMessage: 'This account is not currently associated with an active tenant. Please reach out to your system administrator for assistance.',
  },
  password: {
    id: 'login.password',
    defaultMessage: 'Password',
  },
  passwordForgot: {
    id: 'login.password.forgot',
    defaultMessage: 'Forgot Password?'
  },
  platformViewMode: {
    id: 'login.platformViewMode',
    defaultMessage: 'Platform admin view-only mode',
  },
  rememberMe: {
    id: 'login.rememberMe',
    defaultMessage: 'Remember Me',
  },
  selectButton: {
    id: 'login.selectButton',
    defaultMessage: 'Select',
  },
  selectTenant: {
    id: 'login.selectTenant',
    defaultMessage: 'Select a tenant',
  },
  selectTenantMenu: {
    id: 'login.selectTenantMenu',
    defaultMessage: 'Please Select a Tenant',
  },
  selectTenantReAuthTitle: {
    id: 'login.selectTenantReAuthTitle',
    defaultMessage: 'Authentication is required to switch to this tenant',
  },
  setDefaultTenant: {
    id: 'login.setDefaultTenant',
    defaultMessage: 'Set as Default Tenant',
  },
  signIn: {
    id: 'login.signIn',
    defaultMessage: 'Sign In',
  },
  signInWithEmailAndPassword: {
    id: 'login.signInWithEmailAndPassword',
    defaultMessage: 'Sign in with email and password',
  },
  signInWithSso: {
    id: 'login.signInWithSso',
    defaultMessage: 'Sign in with SSO',
  },
  ssoError: {
    id: 'login.sso.error',
    defaultMessage: 'Please enter Email',
  },
  ssoSignInDescription: {
    id: 'login.sso.signInDescription',
    defaultMessage: "Enter your email address and we'll redirect you to your company's login",
  },
  welcomeMessage: {
    id: 'login.welcomeMessage',
    defaultMessage: 'Sign in to CxEngage',
  },
});
